import { c as _c } from "react/compiler-runtime";
import { Button, cn, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@newfront-insurance/core-ui/v2';
import type { ComponentProps } from 'react';
export type MessageActionsProps = ComponentProps<'div'>;
export function MessageActions(t0) {
  const $ = _c(10);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("flex items-center gap-1", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== props || $[8] !== t1) {
    t2 = <div className={t1} {...props}>{children}</div>;
    $[6] = children;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}
export type MessageActionProps = ComponentProps<typeof Button> & {
  tooltip?: string;
  label?: string;
  isActive?: boolean;
};
export function MessageAction(t0) {
  const $ = _c(32);
  let children;
  let className;
  let label;
  let props;
  let t1;
  let t2;
  let t3;
  let tooltip;
  if ($[0] !== t0) {
    ({
      tooltip,
      children,
      label,
      className,
      variant: t1,
      size: t2,
      isActive: t3,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = label;
    $[4] = props;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = tooltip;
  } else {
    children = $[1];
    className = $[2];
    label = $[3];
    props = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    tooltip = $[8];
  }
  const variant = t1 === undefined ? "transparent" : t1;
  const size = t2 === undefined ? "small" : t2;
  const isActive = t3 === undefined ? false : t3;
  let t4;
  if ($[9] !== className) {
    t4 = cn("text-muted-foreground hover:text-foreground relative size-8 p-1.5", className);
    $[9] = className;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== isActive) {
    t5 = cn("rounded p-0.5", {
      "text-steel-700": isActive
    });
    $[11] = isActive;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== children || $[14] !== t5) {
    t6 = <div className={t5}>{children}</div>;
    $[13] = children;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const t7 = label || tooltip;
  let t8;
  if ($[16] !== t7) {
    t8 = <span className="sr-only">{t7}</span>;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== props || $[19] !== size || $[20] !== t4 || $[21] !== t6 || $[22] !== t8 || $[23] !== variant) {
    t9 = <Button className={t4} size={size} type="button" variant={variant} {...props}>{t6}{t8}</Button>;
    $[18] = props;
    $[19] = size;
    $[20] = t4;
    $[21] = t6;
    $[22] = t8;
    $[23] = variant;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  const button = t9;
  if (tooltip) {
    let t10;
    if ($[25] !== button) {
      t10 = <TooltipTrigger asChild={true}>{button}</TooltipTrigger>;
      $[25] = button;
      $[26] = t10;
    } else {
      t10 = $[26];
    }
    let t11;
    if ($[27] !== tooltip) {
      t11 = <TooltipContent side="bottom"><p>{tooltip}</p></TooltipContent>;
      $[27] = tooltip;
      $[28] = t11;
    } else {
      t11 = $[28];
    }
    let t12;
    if ($[29] !== t10 || $[30] !== t11) {
      t12 = <TooltipProvider><Tooltip>{t10}{t11}</Tooltip></TooltipProvider>;
      $[29] = t10;
      $[30] = t11;
      $[31] = t12;
    } else {
      t12 = $[31];
    }
    return t12;
  }
  return button;
}